import React from "react";
import "./International_Divorce.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import { Helmet } from "react-helmet";

export default function International_Divorce() {
  const seo = {
    title:
      "גירושין בינלאומיים – הליכי גירושין בין מדינות | עורך דין רז יוסף",
    description:
      "גירושין בינלאומיים כאשר בני זוג מתגוררים במדינות שונות, נישאו בחו״ל או מחזיקים בנכסים במדינות שונות. מידע על סמכות שיפוט, חלוקת רכוש, מזונות, ילדים והכרה בפסקי דין זרים.",
    url: "https://razfamilylaw.co.il/International_Divorce",
    image: "https://razfamilylaw.co.il/images/30.jpeg"
  };

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
        <link rel="canonical" href={seo.url} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:url" content={seo.url} />
        <meta property="og:image" content={seo.image} />
        <meta property="og:site_name" content="משרד עורכי דין רז יוסף" />
        <meta property="og:locale" content="he_IL" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content={seo.image} />
      </Helmet>

      <div className="International_Divorce-page">
        <div className="International_Divorce-hero">
          <div className="International_Divorce-overlay">
            <h1>גירושין בינלאומיים</h1>
          </div>
        </div>

        <div className="page3">
          <div className="container">
            <h2 className="top-text">
              גירושין בינלאומיים הם הליכים משפטיים שבהם מעורבת יותר
              ממדינה אחת, למשל כאשר בני זוג מתגוררים במדינות שונות,
              נישאו בחו״ל, בעלי אזרחויות שונות או מחזיקים בנכסים
              במדינות שונות. במקרים אלה יש חשיבות לבחינת סמכות
              השיפוט, הדין החל והאפשרויות המשפטיות העומדות בפני
              בני הזוג בישראל ובמדינות נוספות.
            </h2>

            <div className="content-row">
              <div className="text-box">
                <p>
                  הליך גירושין בינלאומי עשוי לכלול סוגיות משפטיות
                  מורכבות מעבר לעצם סיום הנישואין. בין היתר,
                  עשויות להתעורר שאלות בנוגע למקום שבו ניתן
                  להגיש את התביעה, לחלוקת רכוש הנמצא במדינות
                  שונות, למזונות, לאחריות הורית ולמקום מגוריהם
                  של הילדים.
                </p>

                <p>
                  כאשר קיים קשר בין בני הזוג ליותר ממדינה אחת,
                  חשוב לבחון את הנסיבות המשפטיות לפני פתיחת
                  הליכים. מקום המגורים, האזרחות, מקום הנישואין
                  ומקום הימצאות הנכסים עשויים להשפיע על הסמכות
                  ועל הדרך שבה ניתן לנהל את ההליך.
                </p>
              </div>
            </div>

            <div className="bottom-text">
              <h2 className="main-title">מהם גירושין בינלאומיים?</h2>

              <p>
                גירושין בינלאומיים הם הליכי גירושין שבהם קיים
                קשר משפטי או עובדתי ליותר ממדינה אחת. מצב כזה
                עשוי להתקיים כאשר בני זוג מתגוררים במדינות
                שונות, כאשר אחד מהם אזרח זר, כאשר הנישואין
                נערכו בחו״ל או כאשר לבני הזוג רכוש ונכסים
                במדינות שונות.
              </p>

              <p>
                במקרים אלה עשויות להתעורר שאלות הנוגעות
                לסמכות השיפוט של בתי המשפט והערכאות במדינות
                השונות, לדין החל על בני הזוג ולהכרה בהחלטות
                משפטיות שניתנו מחוץ לישראל.
              </p>

              <h2 className="main-title">
                היכן ניתן להגיש תביעת גירושין בינלאומית?
              </h2>

              <p>
                אחת השאלות המרכזיות בהליך גירושין בינלאומי
                היא באיזו מדינה ניתן לפתוח בהליך. התשובה
                תלויה בנסיבות המקרה ובהוראות הדין הרלוונטיות.
                בין השיקולים שעשויים להיבחן נמצאים מקום
                המגורים של בני הזוג, אזרחותם, מקום מושבם
                ומקום הנישואין.
              </p>

              <p>
                כאשר קיימת זיקה לישראל, יש לבחון האם
                מתקיימים התנאים המאפשרים לנהל את ההליך
                בישראל. בענייני נישואין וגירושין של יהודים
                בישראל עשויה להיות סמכות לבית הדין הרבני,
                ואילו סוגיות משפחתיות נוספות עשויות להיות
                נתונות לסמכות בית המשפט לענייני משפחה
                או לערכאה אחרת בהתאם לדין.
              </p>

              <p>
                חשוב להדגיש כי הסמכות לדון בעצם הגירושין
                אינה בהכרח זהה לסמכות לדון בחלוקת רכוש,
                במזונות או בענייני ילדים. יש לבחון כל
                סוגיה בהתאם לכללי הסמכות החלים עליה.
              </p>

              <h2 className="main-title">
                גירושין כאשר בני הזוג בעלי אזרחויות שונות
              </h2>

              <p>
                כאשר בני זוג מחזיקים באזרחויות שונות,
                עשויות להתעורר שאלות הנוגעות לדין החל
                על הנישואין והגירושין, לסמכות בתי המשפט
                במדינות השונות ולהכרה בהליך במדינה
                שבה אחד מבני הזוג מתגורר.
              </p>

              <p>
                לדוגמה, כאשר אחד מבני הזוג אזרח ישראלי
                והשני אזרח של מדינה אחרת, יש לבחון
                האם ניתן לנהל את הליך הגירושין בישראל,
                האם נדרשים הליכים נוספים במדינה האחרת
                ומה תהיה המשמעות של פסק הדין בכל אחת
                מהמדינות הרלוונטיות.
              </p>

              <h2 className="main-title">
                הכרה בישראל בגירושין שנערכו בחו״ל
              </h2>

              <p>
                בני זוג שהתגרשו במדינה זרה עשויים
                להידרש להסדיר את רישום הגירושין בישראל.
                ההליך תלוי בסוג הנישואין, בדרך שבה
                בוצעו הגירושין, בזהות הערכאה שנתנה
                את ההחלטה ובהוראות הדין הרלוונטיות.
              </p>

              <p>
                לצורך הסדרת הרישום עשויים להידרש
                מסמכים רשמיים ממדינת הגירושין,
                תעודת גירושין או פסק דין, תרגום
                מאושר ואימות מתאים של המסמכים.
                יש לבדוק את הדרישות בהתאם למדינה
                ולנסיבות המקרה.
              </p>

              <h2 className="main-title">
                חלוקת רכוש ונכסים במדינות שונות
              </h2>

              <p>
                אחד הנושאים המורכבים בגירושין
                בינלאומיים הוא חלוקת רכוש כאשר
                לבני הזוג נכסים במדינות שונות.
                נכסים אלה עשויים לכלול דירות,
                חשבונות בנק, חסכונות, זכויות
                פנסיוניות, עסקים והשקעות.
              </p>

              <p>
                יש לבחון את הדין החל על יחסי
                הממון בין בני הזוג, את מקום
                הימצאות הנכסים ואת האפשרות
                לקבל מידע ולממש זכויות ביחס
                לנכסים הנמצאים מחוץ לישראל.
              </p>

              <p>
                כאשר קיימים נכסים בישראל ובחו״ל,
                חשוב לבחון את התמונה הכלכלית
                המלאה ולבדוק כיצד ניתן להסדיר
                את חלוקת הרכוש באופן משפטי
                המתאים לנסיבות המקרה.
              </p>

              <h2 className="main-title">
                מזונות בגירושין בינלאומיים
              </h2>

              <p>
                כאשר בני זוג מתגוררים במדינות
                שונות, עשויות להתעורר שאלות
                בנוגע לסמכות לדון בתביעת מזונות,
                לדין החל על החיוב וליכולת לגבות
                את התשלום במדינה שבה נמצא החייב.
              </p>

              <p>
                כאשר מדובר במזונות ילדים, יש
                חשיבות גם למקום מגוריהם של
                הילדים, לנסיבות המשפחתיות
                ולהחלטות שניתנו במדינות השונות.
                יש לבחון את האפשרויות המשפטיות
                ואת הדרכים להכרה ולאכיפה של
                חיובים בין מדינות.
              </p>

              <h2 className="main-title">
                אחריות הורית וזמני שהות כאשר ההורים מתגוררים במדינות שונות
              </h2>

              <p>
                כאשר ההורים מתגוררים במדינות
                שונות, הסוגיות הנוגעות לאחריות
                הורית ולזמני שהות עשויות להיות
                מורכבות במיוחד. יש לבחון את
                מקום מגוריו הרגיל של הילד,
                את טובתו ואת האפשרות לקיים
                קשר רציף ומשמעותי עם שני הוריו.
              </p>

              <p>
                מעבר של אחד ההורים למדינה אחרת
                או רצון להעביר את מקום מגוריו
                של הילד עשויים לעורר שאלות
                משפטיות משמעותיות. במקרים
                המתאימים, מעבר כזה עשוי לדרוש
                הסכמה של ההורה האחר או אישור
                של הערכאה המוסמכת.
              </p>

              <h2 className="main-title">
                אמנת האג והעברת ילדים בין מדינות
              </h2>

              <p>
                אמנת האג בדבר ההיבטים האזרחיים
                של חטיפה בינלאומית של ילדים
                נועדה להתמודד עם מקרים שבהם
                ילד הועבר למדינה אחרת או הוחזק
                בה שלא כדין, בניגוד לזכויות
                המשמורת הרלוונטיות.
              </p>

              <p>
                כאשר האמנה חלה על המקרה,
                עשוי להתנהל הליך שמטרתו
                להכריע בשאלת החזרת הילד
                למדינה שבה היה מקום מגוריו
                הרגיל לפני ההעברה או ההחזקה
                שלא כדין. מדובר בהליך משפטי
                ייחודי המחייב בחינה של
                נסיבות המקרה והוראות האמנה.
              </p>

              <h2 className="main-title">
                הכרה ואכיפה של פסקי דין זרים בישראל
              </h2>

              <p>
                כאשר ניתן פסק דין בענייני
                משפחה במדינה זרה, עשויה
                להתעורר השאלה האם ניתן
                להכיר בו או לאכוף אותו בישראל.
                הדבר עשוי להיות רלוונטי לפסקי
                דין הנוגעים למזונות, לחיובים
                כספיים ולסוגיות משפחתיות נוספות.
              </p>

              <p>
                ההכרה והאכיפה בישראל כפופות
                לתנאים הקבועים בדין הישראלי
                ולהסדרים המשפטיים הרלוונטיים.
                לא כל החלטה שניתנה בחו״ל
                מקבלת תוקף אוטומטי בישראל,
                ולכן יש לבדוק את המסלול
                המשפטי המתאים.
              </p>

              <h2 className="main-title">
                ניהול הליכים מקבילים בישראל ובחו״ל
              </h2>

              <p>
                לעיתים בני זוג פותחים בהליכים
                משפטיים במדינות שונות במקביל.
                מצב כזה עלול ליצור מחלוקות
                בנוגע לסמכות השיפוט, להחלטות
                סותרות, להוצאות משפטיות
                ולניהול יעיל של הסכסוך.
              </p>

              <p>
                חשוב לבדוק אילו הליכים כבר
                נפתחו, האם ניתנו החלטות
                שיפוטיות ומה המשמעות של
                פתיחת הליך נוסף במדינה אחרת.
                בחינה מוקדמת של המצב המשפטי
                עשויה לסייע בצמצום מחלוקות
                ובהגנה על זכויות הצדדים.
              </p>

              <h2 className="main-title">
                טעויות שכדאי להימנע מהן בגירושין בינלאומיים
              </h2>

              <p>
                פתיחת הליך משפטי במדינה מסוימת
                ללא בדיקת הסמכות, התעלמות
                מהליכים המתנהלים במדינה אחרת
                או הסתמכות על מסמכים שאינם
                מוכרים בישראל עלולות ליצור
                קשיים משפטיים בהמשך הדרך.
              </p>

              <p>
                חשוב להימנע מהנחה שפסק דין
                שניתן במדינה אחת יהיה תקף
                באופן אוטומטי במדינה אחרת.
                יש לבדוק מראש את דרישות
                ההכרה והאכיפה ואת ההשלכות
                האפשריות של כל צעד משפטי.
              </p>

              <h2 className="main-title">
                חשיבות הייעוץ המשפטי לפני פתיחת הליך
              </h2>

              <p>
                גירושין בינלאומיים מחייבים
                בחינה של מספר מערכות משפטיות
                ושל סוגיות הקשורות לסמכות,
                לדין החל ולהכרה בהחלטות
                במדינות שונות.
              </p>

              <p>
                ייעוץ משפטי מוקדם מאפשר
                לבחון את נסיבות המקרה,
                להבין אילו הליכים ניתן
                לפתוח בישראל או במדינה
                אחרת, ולגבש דרך פעולה
                המתאימה לזכויות ולצרכים
                של בני הזוג והילדים.
              </p>

              <h2 className="main-title">
                משרד עורכי דין רז יוסף – ייעוץ בגירושין בינלאומיים
              </h2>

              <p>
                משרד עורכי דין רז יוסף מעניק
                ייעוץ וייצוג בתחום דיני המשפחה,
                לרבות סוגיות הנוגעות להליכי
                גירושין, סמכויות שיפוט,
                חלוקת רכוש, מזונות
                ואחריות הורית.
              </p>

              <p>
                כאשר הליך הגירושין כולל
                קשר למדינה זרה, חשוב לבחון
                את נסיבות המקרה ואת ההשלכות
                המשפטיות בישראל ובמדינות
                הרלוונטיות. ניתן לפנות למשרד
                לקבלת ייעוץ משפטי ובחינת
                האפשרויות העומדות בפניכם.
              </p>
            </div>

            <ContactSection2 />

            <div className="links">
              <Link
                to="/The_race_for_authority"
                className="link-right"
              >
מרוץ הסמכויות               </Link>

              <Link
                to="/Civil_Marriage_and_Invalid_Marriage"
                className="link-left"
              >
נישואין אזרחיים ופסולי חיתון              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}